<template>
    <select
        :value="value"
        @input="handleInput"
        class="form-control"
        style="font-size: 12px; height: 30px"
    > 
        <option
            v-if="!selectFirst"
            :value="processedDefaultValue.value"
        >
            {{processedDefaultValue.text}} ({{$t("general:default")}})
        </option>
        <option 
            v-for="(option, option_idx) in choices" 
            :value="option.value"
            :key="'option-'+option_idx"
        >
            {{option.text}}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },
        choices: {
            default: () => [],
            // Example: [{value: "1", text: "One"}, {value: "2", text: "Two"}]
        },
        selectFirst: {
            type: Boolean,
            default: false,
        },
        defaultValue: {
            type: [Object, String],
            required: true
        },
    },
    computed: {
        processedDefaultValue() {
            if (typeof this.defaultValue === "string") {
                return { value: null, text: this.defaultValue };
            } else if (typeof this.defaultValue === "object" && this.defaultValue !== null) {
                if (this.defaultValue.hasOwnProperty("value") && this.defaultValue.hasOwnProperty("text")) {
                    return this.defaultValue;
                } else {
                    console.warn("defaultValue object must have 'value' and 'text' properties");
                    return { value: null, text: "" };
                }
            }
            return { value: null, text: "" };
        }
    },
    methods: {
        handleInput: function(event) {
            let val = event.target.value;
            if (val==="") {val = null}
            this.$emit("input", val);
        }
    },
}
</script>
